import * as React from 'react';

export const ViewFeedTemplate = React.lazy(() => import('./ViewFeedTemplate'));
